import { Grid } from '@mui/material'
import React, { FunctionComponent } from 'react'

import { SimpleContainerBox } from '../../../base/components/Container/SimpleBox'
import Breadcrumb from '../../../base/components/Template/Breadcrumb/Breadcrumb'
import { loteRoutesMap } from '../loteRoutes'
import LoteListado from './listado/LoteListado'

interface OwnProps {}

type Props = OwnProps

/**
 * Gestion o paginba principal para gestionar los lote
 * @param props
 * @constructor
 */
const LoteGestion: FunctionComponent<Props> = (props) => {
  return (
    <SimpleContainerBox maxWidth={'xl'}>
      <Breadcrumb routeSegments={[loteRoutesMap.gestion]} />
      <Grid container spacing={2}>
        <Grid size={12}>
          <LoteListado />
        </Grid>
      </Grid>
    </SimpleContainerBox>
  )
}

export default LoteGestion
